import $ from "jquery";

$(function () {
    if ($(document).find(".bl-fernwaermeform-arosa").length > 0) {
        initFernwaermeForm();
    }
});

function initFernwaermeForm() {
    initFormBasic();
    initRequiredCheckboxGroup('.wwa__row .wwa__toggle input[type="checkbox"]', 'Bitte wählen Sie mindestens einen Energieträger aus.');
    initRequiredCheckboxGroup('input[name="waermeabgabe[]"]', 'Bitte wählen Sie mindestens eine Wärmeabgabe aus.');
    var paging = initFormPaging();
    initFormSubmit(paging);
    window.fillDemoData = fillDemoData;
}

function showValidationError(status) {
    status.hidden = false;
    status.className = 'status status--error';
    status.textContent = 'Bitte ergänzen Sie die markierten Pflichtfelder.';
}

function initFormBasic() {
    var form = document.getElementById('fw-form');

    // Enable dependent fields only when their parent option is selected.
    // By default any checked value other than 'nein' turns the target on; an
    // element can instead require one specific value via data-toggle-value.
    function sync(key) {
        var on = Array.prototype.some.call(
            form.querySelectorAll('[data-toggle="' + key + '"]'),
            function (el) {
                if (!el.checked) return false;
                var requiredValue = el.getAttribute('data-toggle-value');
                return requiredValue !== null ? el.value === requiredValue : el.value !== 'nein';
            }
        );
        form.querySelectorAll('[data-target="' + key + '"]').forEach(function (el) {
            el.disabled = !on;
            if (!on) { el.checked = false; if (el.type !== 'radio' && el.type !== 'checkbox') el.value = ''; }
            if (el.hasAttribute('data-hide')) { el.hidden = !on; }
        });
    }

    var keys = [];
    form.querySelectorAll('[data-toggle]').forEach(function (el) {
        var k = el.getAttribute('data-toggle');
        if (keys.indexOf(k) === -1) keys.push(k);
        el.addEventListener('change', function () { sync(k); });
    });
    keys.forEach(sync);

    //document.getElementById('print-btn').addEventListener('click', function () { window.print(); });
}

// Require at least one checked checkbox within a group of independently-named checkboxes.
// Native `required` only works per-checkbox, so custom validity is used to require the group as a whole.
function initRequiredCheckboxGroup(selector, message) {
    var form = document.getElementById('fw-form');
    var boxes = Array.prototype.slice.call(form.querySelectorAll(selector));
    if (!boxes.length) return;

    function sync() {
        var anyChecked = boxes.some(function (el) { return el.checked; });
        boxes.forEach(function (el) { el.setCustomValidity(anyChecked ? '' : message); });
    }

    boxes.forEach(function (el) { el.addEventListener('change', sync); });
    sync();
}

function initFormPaging() {
    var form = document.getElementById('fw-form');
    var status = document.getElementById('status');
    var sections = Array.prototype.slice.call(form.querySelectorAll('section.block'));
    var btnPrev = document.getElementById('btn-prev');
    var btnNext = document.getElementById('btn-next');
    var btnSubmit = document.getElementById('btn-submit');
    var current = 0;

    // Some `anliegen` choices have nothing left to collect on steps 2/3, so they
    // let the visitor submit right from step 1 instead of paging through.
    function isDirectSubmit() {
        var checked = form.querySelector('[data-direct-submit]:checked');
        return !!checked && checked.getAttribute('data-direct-submit') === 'true';
    }

    function updateActions() {
        var isLast = current === sections.length - 1;
        var showSubmit = isLast || isDirectSubmit();
        btnPrev.hidden = current === 0;
        btnNext.hidden = showSubmit;
        btnSubmit.hidden = !showSubmit;
        btnSubmit.disabled = !showSubmit;
    }

    form.querySelectorAll('[data-direct-submit]').forEach(function (el) {
        el.addEventListener('change', updateActions);
    });

    function showStep(index, scrollIntoView = true) {
        current = index;
        sections.forEach(function (section, i) { section.hidden = i !== index; });

        updateActions();

        status.hidden = true;
        if (scrollIntoView) {
            //sections[index].scrollIntoView({ block: 'start', behavior: 'smooth' });
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    function validateStep(index) {
        var invalid = sections[index].querySelector(':invalid');
        if (invalid) {
            sections[index].classList.add('was-validated');
            showValidationError(status);
            invalid.focus();
            invalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
            //invalid.reportValidity();
            return false;
        }
        return true;
    }

    btnNext.addEventListener('click', function () {
        if (!validateStep(current)) return;
        showStep(Math.min(current + 1, sections.length - 1));
    });

    btnPrev.addEventListener('click', function () {
        showStep(Math.max(current - 1, 0));
    });

    showStep(0, false);

    return {
        goToField: function (field) {
            var index = sections.findIndex(function (section) { return section.contains(field); });
            if (index !== -1) { showStep(index); }
        }
    };
}

function initFormSubmit(paging) {
    var form = document.getElementById('fw-form');
    var status = document.getElementById('status');
    var sections = Array.from(form.querySelectorAll('section.block'));
    var actions = form.querySelector('.actions');
    var btnSubmit = document.getElementById('btn-submit');

    function showSubmitError(message) {
        status.hidden = false;
        status.className = 'status status--error';
        status.textContent = message || 'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.';
        status.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    // Hiding a section does not bar its fields from constraint validation, so a
    // plain form.checkValidity() would still trip on required fields in steps
    // that were skipped (e.g. via direct-submit). Only check visible sections,
    // same as validateStep() does per-step during normal paging.
    function firstInvalidVisibleField() {
        for (var i = 0; i < sections.length; i++) {
            if (sections[i].hidden) continue;
            var invalid = sections[i].querySelector(':invalid');
            if (invalid) return invalid;
        }
        return null;
    }

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        status.hidden = false;

        var first = firstInvalidVisibleField();
        if (first) {
            form.classList.add('was-validated');
            showValidationError(status);
            if (paging) { paging.goToField(first); }
            first.focus();
            first.scrollIntoView({ block: 'center', behavior: 'smooth' });
            return;
        }

        status.hidden = true;
        if (btnSubmit) { btnSubmit.disabled = true; }

        fetch('/api/fernwaermeform/submithandler-arosa.php', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'application/json' }
        })
            .then(function (response) {
                return response.json().catch(function () { return {}; }).then(function (json) {
                    if (!response.ok || !json.success) {
                        throw new Error(json.error || 'Unbekannter Fehler');
                    }
                    return json;
                });
            })
            .then(function () {
                // Hide all section.block and the paging controls, the form is done.
                sections.forEach(function (section) { section.hidden = true; });
                if (actions) {
                    actions.hidden = true;
                }

                var directSubmit = form.querySelector('[data-direct-submit]:checked');
                var isDirectSubmit = !!directSubmit && directSubmit.getAttribute('data-direct-submit') === 'true';

                status.hidden = false;
                status.className = 'status';
                status.textContent = isDirectSubmit
                    ? 'Herzlichen Dank für Ihre Rückmeldung und Ihre Angaben!\n\nIhr Team der Heizwerk Arosa AG'
                    : 'Herzlichen Dank für Ihr Interesse an einem Fernwärmeanschluss.\n\nWir werden Ihre Anfrage prüfen und Ihnen innerhalb der nächsten 10 Arbeitstage eine unverbindliche Grobofferte zustellen.\n\nIhr Team der Heizwerk Arosa AG';
                status.scrollIntoView({ block: 'center', behavior: 'smooth' });
            })
            .catch(function (err) {
                showSubmitError(err.message);
            })
            .finally(function () {
                if (btnSubmit) { btnSubmit.disabled = false; }
            });
    });
}






// Fills the form with example values, useful for testing during development.
// Call from the browser console: fillDemoData()
function fillDemoData() {
    var form = document.getElementById('fw-form');
    if (!form) return;

    function setValue(name, value) {
        var el = form.querySelector('[name="' + name + '"]');
        if (!el) return;
        el.value = value;
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function setChecked(name, value) {
        // For single checkboxes without an explicit value attribute (e.g. toggles),
        // just check the sole element for that name.
        var el = value === undefined
            ? form.querySelector('[name="' + name + '"]')
            : form.querySelector('[name="' + name + '"][value="' + value + '"]');
        if (!el) return;
        el.checked = true;
        el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 1) Angaben Eigentümer/in
    setChecked('eigentumsform', 'Eigentümer/in Grundstück');
    setValue('name', 'Muster');
    setValue('vorname', 'Max');
    setValue('strasse', 'Musterstrasse 12');
    setValue('plzort', '6000 Luzern');
    setValue('telefon', '041 123 45 67');
    setValue('email', 'max.muster@example.com');

    setChecked('anliegen', 'Richtofferte');
    setValue('anmerkungen', 'Test.\nLorem ipsum dolor sit amet, consetetur sadipscing elitr.');

    // 2) Angaben zum Objekt
    setValue('parzelle', '1234');
    setChecked('objektart', 'Altbau');
    setValue('objekt_strasse', 'Musterstrasse 12');
    setValue('objekt_plzort', '6000 Luzern');
    setValue('baujahr', '1978');
    setChecked('gebaeudetyp', 'Einfamilienhaus');
    setValue('anz_stockwerke', '2');
    setValue('anz_wohnungen', '1');
    setValue('anz_bewohner', '4');

    setChecked('sanierung', 'ja');
    setValue('sanierung_jahr', '2015');
    setValue('sanierung_welche', 'Fenster, Fassadendämmung');

    // 3) Angaben zur aktuellen Gebäudeheizung inkl. WWA
    setChecked('traeger_heizoel');
    setValue('heizoel_liter', '2200');
    setChecked('heizoel_wwa', 'inkl');

    setChecked('waermeabgabe[]', 'Heizkörper (Radiatoren)');

    setChecked('oeltank_vorhanden');
    setValue('oeltank_liter', '4000');
    setChecked('tank_material', 'Stahltank');
    setChecked('tank_lage', 'aussen (erdverlegt)');

    setChecked('boiler_vorhanden');
    setValue('boiler_liter', '300');

    setValue('energiebezugsflaeche', '180');
}